// @ts-nocheck
import * as Types from '../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
export type DevelopmentCommitmentPotentialLineItemFragment = { __typename?: 'DevelopmentCommitmentPotentialLineItem', costType: Types.CostType, totalCostInCents: number, projects: Array<string>, item: { __typename?: 'Item', displayName: string, id: string, costCode: { __typename?: 'CostCode', displayName: string, id: string } }, location: { __typename?: 'Location', id: string, name: string } };

export const DevelopmentCommitmentPotentialLineItemFragmentDoc = gql`
    fragment DevelopmentCommitmentPotentialLineItem on DevelopmentCommitmentPotentialLineItem {
  item {
    displayName
    id
    costCode {
      displayName
      id
    }
  }
  costType
  location {
    id
    name
  }
  totalCostInCents
  projects
}
    `;